import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import MainLayout from "../layouts/Mainlayout";

export default function Contact() {
  const { register, handleSubmit } = useForm();

  const onSubmit = (data) => console.log(data);

  return (
    <MainLayout>
      <h2 className="text-3xl text-center mb-6">Contact Us 📞</h2>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-md mx-auto space-y-4"
      >
        <input {...register("name")} placeholder="Name" className="w-full p-3 border rounded" />
        <input {...register("email")} placeholder="Email" className="w-full p-3 border rounded" />

        <Button type="submit" variant="contained" color="success" fullWidth>
          Send
        </Button>
      </form>
    </MainLayout>
  );
}